import React from "react";
import {cx} from "../../lib/ClassSet";
import "./PaymentItem.css";
import format from 'date-fns/format'
import {formatStatus} from "../../lib/TextFormatter";

const PaymentItem = (props) => {

  let {data} = props;
  let classes = cx({
    "item": true,
    "payment-list-item": true,
    "u-successful": data.get("successful")
  })

  return (
    <tr className={classes}>
      <td className="field f-date">{format(data.get("createdAt"), "MMM D, YYYY")}</td>
      <td className="field">{formatType(data.get("type"))}</td>
      <td className="field f-amount">{data.get("currency")} {data.get("amount")}</td>
      <td className="field f-method">{formatMethod(data)}</td>
      <td className="field f-result">{formatResult(data)}</td>
      <td className="field f-ref">{data.get("transactionRef")}</td>
      <td className="field f-pi">{data.get("paymentMethodId")}</td>
      <td className="field f-pi">{data.get("paymentIntentId")}</td>
    </tr>
  )
}

function formatMethod(data) {
  const methodAndType = [data.get("paymentMethod"), data.get("type")];

  const creditCardSet = new Set(["link", "card", "google_pay", "apple_pay"]);
  const bankDebitSet = new Set(["sepa_debit", "ach_debit", "us_bank_account"]);

  if (methodAndType.filter(mt => creditCardSet.has(mt)).length > 0) {
    return [data.get("cardBrand"), "****", data.get("cardLast4")].join(" ");
  } else if (methodAndType.filter(mt => bankDebitSet.has(mt)).length > 0) {
    return `${data.get("countryCode")}****${data.get("cardLast4")}`;
  }

  return formatType(data.get("paymentMethod"));
}

function formatResult(data) {
  return data.get("successful") ? "Success" : data.get("errorCode");
}

function formatType(type) {
  return formatStatus(type) || "--";
}

export default PaymentItem;